import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex } from 'antd';

import { CreateSourceForm } from 'entities/Source';
import { OnboardingText } from 'features/Onboarding';

interface IStepTwoProps extends HTMLAttributes<HTMLDivElement> {}

export const StepTwo: FC<IStepTwoProps> = ({ className, ...props }) => {
	const { t } = useTranslation();

	return (
		<Flex {...props} vertical gap={20} className={className}>
			<OnboardingText
				isSteps
				header={t('Давайте добавим вашу первую площадку')}
				text={t(
					'Укажите необходимую информацию ниже. Это поможет нам показать вам идеальные предложения для вашей площадки.',
				)}
			/>
			<CreateSourceForm isOnboarding />
		</Flex>
	);
};
